// Shipping Protection toggle handler
// Adds or removes the configured protection variant on checkbox change
(function() {
  var enforceInProgress = false;
  
  function getOptOut() {
    return localStorage.getItem("spOptedOut") === "true";
  }

  function setOptOut(val) {
    localStorage.setItem("spOptedOut", val ? "true" : "false");
  }

  function setCheckoutDisabled(disabled) {
    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn) {
      btn.disabled = !!disabled;
      if (btn.classList) {
        btn.classList.toggle('is-disabled', !!disabled);
      }
    }
  }

  function getShippingProtectionVariantId() {
    if (window.shippingProtectionVariantId) return window.shippingProtectionVariantId;
    var input = document.querySelector('.cart-drawer__shipping-protection-checkbox-input');
    if (input && input.value) {
      window.shippingProtectionVariantId = input.value;
      return input.value;
    }
    return null;
  }

  function enforceShippingProtectionRule() {
    if (enforceInProgress) return;
    var spVariantId = getShippingProtectionVariantId();
    if (!spVariantId) return;

    enforceInProgress = true;
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (!cart || !cart.items) return;

        if (getOptOut()) {
          var checkbox = document.querySelector('.cart-drawer__shipping-protection-checkbox-input');
          if (checkbox) checkbox.checked = false;
          return;
        }

        if (cart.items.length === 1 && cart.items[0].id != spVariantId) {
          var checkbox = document.querySelector('.cart-drawer__shipping-protection-checkbox-input');
          if (checkbox) checkbox.checked = true;
          addProtection(spVariantId, checkbox);
          return;
        }

        if (cart.items.length === 1 && (cart.items[0].id + '') === (spVariantId + '')) {
          var removeBody = JSON.stringify({ line: 1, quantity: 0 });
          return fetch(`${routes.cart_change_url}`, { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, 
            body: removeBody 
          }).then(r => {
            if (!r.ok) throw new Error('Change failed');
          }).then(refreshCartDrawer);
        }
      })
      .catch(() => {})
      .finally(() => { enforceInProgress = false; });
  }

  function refreshCartDrawer(button) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${routes.cart_url}?section_id=cart-drawer`, true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        const html = new DOMParser().parseFromString(xhr.responseText, 'text/html');

        // Remove the `drawer__inner-empty` element if it exists
        const emptyElement = document.querySelector('.drawer__inner-empty');
        if (emptyElement) {
          emptyElement.remove();
        }

        const cartDrawer = document.querySelector('cart-drawer');
        // Sync wrapper is-empty state with fetched markup
        const fetchedWrapper = html.querySelector('cart-drawer');
        if (cartDrawer && fetchedWrapper) {
          if (fetchedWrapper.classList.contains('is-empty')) {
            cartDrawer.classList.add('is-empty');
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        }

        // Replace the content of the specified selectors
        const selectors = ['#CartDrawer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
            if (cartDrawer) {
              cartDrawer.classList.add('active');
            }
          }
        }

        setTimeout(function() {
          if (typeof window.initUpsellSwiper === 'function') {
            window.initUpsellSwiper();
          }
          // Re-run enforcement after the drawer content updates
          enforceShippingProtectionRule();
        }, 100);

        if (button) {
          button.disabled = false;
        }
        setCheckoutDisabled(false);
      } else {
        if (button) {
          button.disabled = false;
        }
        console.error('Failed to refresh cart drawer:', xhr.statusText);
        setCheckoutDisabled(false);
      }
    };
    xhr.onerror = function () {
      if (button) {
        button.disabled = false;
      }
      console.error('Error during cart drawer refresh.');
      setCheckoutDisabled(false);
    };
    xhr.send();
  }

  function addProtection(variantId, checkbox) {
    // Ensure only one unit exists; if already present, skip adding and just refresh
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var existingLine = null;
        var existingQty = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id == variantId) { // eslint-disable-line eqeqeq
            existingLine = i + 1;
            existingQty = cart.items[i].quantity;
            break;
          }
        }
        if (existingLine) {
          // If shipping protection is already in the cart, just refresh it
          if (existingQty === 1) {
            refreshCartDrawer(checkbox);
            return;
          } else {
            // If there is more than 1, update the quantity to 1 and refresh
            const body = JSON.stringify({ line: existingLine, quantity: 1 });
            return fetch(`${routes.cart_change_url}`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body })
              .then(function(r){ 
                if (!r.ok) throw new Error('Change failed'); 
              })
              .then(function(){ refreshCartDrawer(checkbox); })
              .catch(function(err){
                console.error('Failed to set SP qty to 1:', err);
                if (checkbox) {
                  checkbox.checked = false;
                  checkbox.disabled = false;
                }
                setCheckoutDisabled(false);
              });
          }
        }
        // Not in cart, so we add one
        const body = JSON.stringify({ id: variantId, quantity: 1 });
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              refreshCartDrawer(checkbox);
            } else {
              console.error('Failed to add shipping protection:', xhr.statusText);
              // Revert UI state on failure
              if (checkbox) {
                checkbox.checked = false;
                checkbox.disabled = false;
              }
              setCheckoutDisabled(false);
            }
          }
        };
        xhr.onerror = function () {
          console.error('Error during add shipping protection request.');
          if (checkbox) {
            checkbox.checked = false;
            checkbox.disabled = false;
          }
          setCheckoutDisabled(false);
        };
        xhr.send(body);
    })
    .catch(function(err) {
        console.error('Failed to read cart before adding:', err);
        if (checkbox) {
          checkbox.checked = false;
          checkbox.disabled = false;
        }
        setCheckoutDisabled(false);
    });
  }

  function removeProtection(variantId, checkbox) {
    // Find the line item for the variant to remove just one if present
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var lineToRemove = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id == variantId) { // eslint-disable-line eqeqeq
            lineToRemove = i + 1; // Shopify lines are 1-based
            break;
          }
        }
        if (!lineToRemove) {
          // Nothing to remove; just refresh to ensure UI is consistent
          refreshCartDrawer(checkbox);
          return;
        }

        const body = JSON.stringify({ line: lineToRemove, quantity: 0 });
        fetch(`${routes.cart_change_url}`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body })
          .then(function(res) {
            if (!res.ok) throw new Error('Change failed');
            return res.json();
          })
          .then(function() {
            refreshCartDrawer(checkbox);
          })
          .catch(function(err) {
            console.error('Failed to remove shipping protection:', err);
            if (checkbox) {
              checkbox.checked = true;
              checkbox.disabled = false;
            }
            setCheckoutDisabled(false);
          });
      })
      .catch(function(err) {
        console.error('Failed to read cart before removal:', err);
        if (checkbox) {
          checkbox.checked = true;
          checkbox.disabled = false;
        }
        setCheckoutDisabled(false);
      });
  }

  window.handleShippingProtectionChange = function(event, el) {
    var checkbox = el || (event && event.currentTarget);
    if (!checkbox) return;

    // Disable to prevent double clicks while processing
    checkbox.disabled = true;
    setCheckoutDisabled(true);

    var variantId = checkbox.value;
    if (!variantId) {
      checkbox.disabled = false;
      return;
    }

    if (checkbox.checked) {
      // Ensure only 1 shipping protection is added
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
            var existingProtection = cart.items.some(item => item.id == variantId);
            if (existingProtection) {
              // If it's already in the cart, do nothing and refresh
              refreshCartDrawer(checkbox);
            } else {
              addProtection(variantId, checkbox);
              setOptOut(false);
            }
        })
      .catch(function(err) {
        console.error('Error checking cart for existing protection:', err);
        checkbox.disabled = false;
        setCheckoutDisabled(false);
      });
    } else {
      removeProtection(variantId, checkbox);
      setOptOut(true);
    }
  };

  // Subscribe to cart update events to enforce rule on any quantity changes
  try {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ enforceShippingProtectionRule(); });
    }
  } catch(e) { /* noop */ }

  // Observe DOM replacements of the cart drawer to enforce after section render
  try {
    var observer = new MutationObserver(function(mutations){
      var needsCheck = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
            // If CartDrawer element is affected
            if (document.getElementById('CartDrawer')) {
              needsCheck = true;
            }
          }
        }
      }
      if (needsCheck) {
        // Debounce slightly
        setTimeout(enforceShippingProtectionRule, 50);
      }
    });
    observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  } catch(e) { /* noop */ }

  // Initial check on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceShippingProtectionRule);
  } else {
    enforceShippingProtectionRule();
  }
})();

